import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export var replyClosed = createAction(reduxKey + "/REPLY_CLOSED", function (commentId) { return ({ commentId: commentId }); });
//# sourceMappingURL=actionCreators.js.map